import { NgModule } from '@angular/core';
import { SharedModule } from '@app/shared';
import { RulesManagementComponent } from '@app/authorized/policyEngine/rules-management/rules-management.component';
import { RuleListComponent } from '@app/authorized/policyEngine/rules-management/rule-list/rule-list.component';
import { RuleItemComponent } from '@app/authorized/policyEngine/rules-management/rule-item/rule-item.component';
import { ReactiveFormsModule } from '@angular/forms';

@NgModule({
    imports: [SharedModule, ReactiveFormsModule],
    declarations: [
        RuleListComponent,
        RuleItemComponent,
        RulesManagementComponent
    ],
    entryComponents: [RulesManagementComponent],
    exports: [RulesManagementComponent]
})
export class RulesManagementModule {
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/rules-management/rules-management.module.ts